import { render, staticRenderFns } from "./InternalPages.vue?vue&type=template&id=088f4d6d&scoped=true"
import script from "./InternalPages.vue?vue&type=script&lang=js"
export * from "./InternalPages.vue?vue&type=script&lang=js"
import style0 from "./InternalPages.vue?vue&type=style&index=0&id=088f4d6d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "088f4d6d",
  null
  
)

export default component.exports